export default [
    {
        path: "/sports/:id(\\d+)/:item_id?",
        name: "_sports",
        props:(route)=>({
            sports_id:route.params.id,
            item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/Home/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"线上运动会"
        }
    },
    // 嘉定定制页面
    {
        path: "/jdsports/:id(\\d+)/:item_id?",
        name: "_sports2",
        props:(route)=>({
            sports_id:route.params.id,
            item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/Home/Index2.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"线上运动会"
        }
    },
    {
        path: "/jsports/:id(\\d+)/:item_id?",
        name: "_sports3",
        props:(route)=>({
            sports_id:route.params.id,
            item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/Move/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"线上运动会",
            bgcolor: "#FEF5DA"
        }
    },
    {
        path: "/sports/item/:item_id",
        name: "sportsItem",
        props:(route)=>({
            item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/ItemList/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"列表"
        }
    },
    {
        path: "/sports/detail/:item_sub_id/:sports_id/:item_id?",
        name: "sportsDetail",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/Detail/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"详情"
        }
    },
    {
        path: "/sports/detailx/:item_sub_id/:sports_id",
        name: "sportsDetailX",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/DetailX/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"详情"
        }
    },
    {
        path: "/sports/ques/:acid",
        name: "sportsQues",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/DetailX/ques.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"奥运小知识"
        }
    },
    {
        path: "/sports/join/:item_sub_id/:sports_id/:signtype",
        name: "joinSports",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/Register/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"报名"
        }
    },
		{
		    path: "/sports/join2/:form_id/:signtype",
		    name: "joinSports2",
		    props:true,
		    component: () => import(/* webpackChunkName: "home" */"../views/Sports/Register/Index2.vue"),
		    meta: {
		        requiresAuth: true,
		        showloading: false,
		        title:"服务申请"
		    }
		},
		{
		    path: "/sports/join3/:item_sub_id/:sports_id/:signtype",
		    name: "joinSports3",
		    props:true,
		    component: () => import(/* webpackChunkName: "home" */"../views/Sports/Register/Index3.vue"),
		    meta: {
		        requiresAuth: true,
		        showloading: false,
		        title:"报名"
		    }
		},
    {
        path: "/sports/voteresult/:item_sub_id/:sports_id",
        name: "sportsResultVote",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/Detail/result.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"投票"
        }
    },
    {
        path: "/sports/result/:item_sub_id/:sports_id",
        name: "sportsResult",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/Result/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"我的"
        }
    },
    {
        path: "/sports/rank/:item_sub_id/:sports_id/:item_id?",
        name: "sportsRank",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/Rank/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"排行"
        }
    },
    {
        path: "/sports/grouprank/:item_sub_id/:sports_id/:item_id?",
        name: "sportsGroupRank",
        props:true,
        component: () => import( /* webpackChunkName: "activity" */ "../views/Sports/Grouprank/Index.vue"),
        meta: {
            title: "团队排行",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/sports/rankr/:item_sub_id/:sports_id/:item_id?",
        name: "rankResult",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/RankR/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"排行"
        }
    },
    {
        path: "/sports/rankx/:item_sub_id/:sports_id/:item_id?",
        name: "sportsRankX",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sports/RankX/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"排行"
        }
    },
];
